import type { PropsWithChildren } from 'react';

import { useMediaQuery } from '@react-hookz/web';
import Swipe from 'react-easy-swipe';
import { Transition } from 'react-transition-group';

import Cross from 'public/cross.svg';
import { FocusLockAndEscape } from 'src/app/components/PageSections/CardItemOverflowMenuWrapper/FocusLockAndEscape';
import type { TransitionStateType } from 'src/app/types';
import type { ThemeSpaceType } from 'src/styles/theme';
import { theme } from 'src/styles/theme';

import { CloseButton, CloseButtonContainer, ModalContainer, Overlay } from './styles';

export type DirectionType = 'down' | 'up' | 'right' | 'left';

export interface SlideInModalProps
  extends PropsWithChildren<{
    className?: string;
    contentMargin?: ThemeSpaceType;
    direction: DirectionType;
    isShown: boolean;
    modalContainerClassName?: string;
    onClose: () => void;
  }> {}

const SlideInModal = ({
  children,
  className,
  contentMargin,
  direction,
  isShown,
  modalContainerClassName,
  onClose,
}: SlideInModalProps) => {
  const isMobile = useMediaQuery(theme.breakpoints.mediumDown);

  const handleExpandedOnClose = () => {
    if (isMobile) {
      onClose();
    }
  };

  return (
    <FocusLockAndEscape handleEscapePressed={onClose}>
      <Swipe
        onSwipeDown={direction === 'up' ? onClose : undefined}
        onSwipeLeft={direction === 'left' ? onClose : undefined}
        onSwipeRight={direction === 'right' ? onClose : undefined}
        onSwipeUp={direction === 'down' ? onClose : undefined}
      >
        <div className={className}>
          <Overlay onClick={onClose} isShown={isShown} />
          <Transition
            in={isShown}
            timeout={isShown ? 0 : 250}
            unmountOnExit
            mountOnEnter
            addEndListener={(node, done) => {
              node.addEventListener('transitioned', done, false);
            }}
          >
            {(transitionState: TransitionStateType) => (
              <ModalContainer
                className={modalContainerClassName}
                transitionState={transitionState}
                direction={direction}
              >
                <CloseButtonContainer
                  contentMargin={contentMargin}
                  direction={direction}
                  onClick={handleExpandedOnClose}
                >
                  <CloseButton src={Cross} onClick={onClose} />
                </CloseButtonContainer>
                {children}
              </ModalContainer>
            )}
          </Transition>
        </div>
      </Swipe>
    </FocusLockAndEscape>
  );
};

export default SlideInModal;
